import axios from '../../config/axiosConfig';

export default {
	get: () => axios.get(`/get/temporary_arrangement`),
	post: (data) => axios.post(`/update/temporary_arrangement`, data),
	remove: (id) => axios.post(`/delete/temporary_arrangement`, id),
};
